<template>
  <main
    class="menu-show-page"
    data-fullscreen
    v-background-color="$store.getters['ui/getBackgroundColor']"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
  >
    <MainHeader data-element="main-header" :buttonLink="header.link" :buttonText="header.text" />
    <menu-component
    :loaded="true"
    :menu="menu"
    :addItemToBasket="addItemToBasket"
    :removeItemFromBasket="removeItemFromBasket"
    :getMatchingBasketItemsChoicesAndPortions="getMatchingBasketItemsChoicesAndPortions"
    basketLink="/basket"
    :handleCheckoutBtnClick="handleCheckoutBtnClick"
    :emptyText="emptyText"
    :menuLabel="menuLabel"
    />
    <transition name="fade">
      <sticky-footer
      v-if="basketCount"
      data-element="mobile-footer"
      >
      <checkout-btn
        :handleClick="handleCheckoutBtnClick"
        :basketTotal="basketTotal"
        :basketCount="basketCount"
        :inactive="!basketCount"
        :loading="false"
        containerSize="md"
        text="View basket"
        />
      </sticky-footer>
    </transition>
    </main>
</template>

<script>
  import MainHeader from '@/components/ui/MainHeader';
  import iOrderConfig from '@/mixins/iOrderConfig';
  import MenuComponent from '@/components/menu/Menu';
  import menuAndBasket from '@/mixins/menuAndBasket';
  import CheckoutBtn from '@/components/ui/CheckoutBtn';
  import StickyFooter from '@/components/ui/StickyFooter';

  export default {
    name: 'menu-show-page',
    components: {
      MainHeader,
      MenuComponent,
      CheckoutBtn,
      StickyFooter
    },
    data: () => {
      return {
        emptyText: 'Your basket is empty'
      };
    },
    mixins: [
      iOrderConfig,
      menuAndBasket
    ],
    computed: {
      menuLabel () {
        return this.$route.params.menuName === 'drinks' ? 'drinks' : 'food'
      },
      header () {
        return {
          text: this.menuLabel === 'drinks' ? 'Food Menu' : 'Drinks Menu',
          link: `/menus/${this.menuLabel === 'drinks' ? 'food' : 'drinks'}`
        }
      },
      menu () {
        return this.$store.getters['iOrderCore/getMenu'](this.menuLabel);
      },
      tiledBackgroundImageUrl () {
        return this.site &&
                this.site.tiledBackgroundImage &&
                this.site.tiledBackgroundImage.fields &&
                this.site.tiledBackgroundImage.fields.file &&
                this.site.tiledBackgroundImage.fields.file.url
      }
    },
    methods: {
      handleCheckoutBtnClick () {
        this.$router.push('/checkout/basket');
      },
      getItemCount (productId) {
        return this.$store.getters['iOrderCore/getItemCount'](productId);
      },
      addItemToBasket (product, portionModifier, choicesArray) {
        if (this.getItemCount(product.productId) >= 10) return false;
        return this.$store.dispatch('iOrderCore/addItemToBasket', { product, portionModifier, choicesArray });
      },
      removeItemFromBasket (productId) {
        return this.$store.dispatch('iOrderCore/removeLastMatchingProductFromBasket', { productId });
      },
      getMatchingBasketItemsChoicesAndPortions (productId) {
        return this.$store.getters['iOrderCore/getMatchingBasketItemsChoicesAndPortions'](productId);
      },
      async init () {
        this.$store.dispatch('checkNecessaryDataToProceed');
      }
    },
    created () {
      this.init();
    }
  };
</script>


<style lang="scss" scoped>
  .menu-show-page {
    background-color:#fff;
    padding-bottom:24px;
    width:100%;
    margin-top:56px;
    padding:16px 0 24px;
    [data-element='main-header'] {
      position:fixed;
      top:0;
      z-index:2;
    }
    [data-element='mobile-footer'] {
      height:64px;
    }
  }
</style>
